import ChipsAction from './components/chips-action'
import ChipsButton from './components/chips-button'
import ChipsContent from './components/chips-content'
import ChipsIcon from './components/chips-icon'
import ChipsRoot from './components/chips-root'

const ChipsComponent = {
  Root: ChipsRoot,
  Icon: ChipsIcon,
  Button: ChipsButton,
  Action: ChipsAction,
  Content: ChipsContent
}

export default ChipsComponent
